import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import AddressForm from '../AddressForm'
import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {getCompanyContactMail, getCompanyInfo, getContactFirstName, getContactLastName} from './selectors'
import {setCompanyInfo} from './actions'
import {getCountries, getStatesByCountry} from '../../selectors'

class EnterCompanyInfoStep extends TemplateView {
    constructor({
        setCompanyInfo = () => {},
    } = {}) {
        super()

        this.actions = {
            setCompanyInfo,
        }

        this.state = {
            firstName: '',
            lastName: '',
            contactMail: '',
            companyInfo: {
                name: '',
                address: '',
                city: '',
                zip: '',
                country: '',
                state: '',
            },
            countries: [],
            statesByCountry: {},
        }

        this.onStatePropertyChanged('companyInfo', (companyInfo) => {
            this.$companyName.val(companyInfo.name)
            this.companyAddressEditor.setState(companyInfo)
        })

        this.onAnyStatePropertyChanged(['countries', 'statesByCountry'], () => {
            this.companyAddressEditor.setState({
                countries: this.state.countries,
                statesByCountry: this.state.statesByCountry,
            })
        })

        this.onAnyStatePropertyChanged(['firstName', 'lastName', 'contactMail'], () => {
            this.$contactInfo.text(
                messageResource.getMessage('licenses.purchase_lightbox.contact_info', [this.state.firstName, this.state.lastName, this.state.contactMail]))
        })
    }

    templateHtml() {
        return '<div class="enterCompanyInfo">' +
               '    <div class="companyName">' +
               '        <div class="title"><%=companyNameTitle%></div>' +
               '        <input class="companyNameInput" type="text" maxlength="255"/>' +
               '    </div>' +
               '    <div class="companyAddress">' +
               '        <div class="title"><%=companyAddressTitle%></div>' +
               '        <div class="editor"/>' +
               '    </div>' +
               '    <div class="checkContactInformation">' +
               '        <div class="title"><%=checkContactInformationTitle%></div>' +
               '        <div class="contactInfo"/>' +
               '        <div class="contactInfoNote"><%=contactInfoNote%></div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            companyNameTitle: 'licenses.purchase_lightbox.enter_company_name',
            companyAddressTitle: 'licenses.purchase_lightbox.company_address',
            checkContactInformationTitle: 'licenses.purchase_lightbox.check_contact_information',
            contactInfoNote: 'licenses.purchase_lightbox.contact_info_note',
        }
    }

    afterRender() {
        this.$companyName = this.find('.companyNameInput')
        this.$companyName.change(() => this.actions.setCompanyInfo({name: this.$companyName.val()}))

        this.companyAddressEditor = new AddressForm({
            fieldsChangeCallback: this.actions.setCompanyInfo,
        }).init(this.find('.companyAddress .editor'))

        this.$contactInfo = this.find('.contactInfo')
    }
}

export default connect(
    (state) => ({
        companyInfo: getCompanyInfo(state),
        firstName: getContactFirstName(state),
        lastName: getContactLastName(state),
        contactMail: getCompanyContactMail(state),
        countries: getCountries(state),
        statesByCountry: getStatesByCountry(state),
    }),
    (dispatch) => ({
        setCompanyInfo: bindActionCreators(setCompanyInfo, dispatch),
    })
)(EnterCompanyInfoStep)


// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/purchaseLightBox/EnterCompanyInfoStep.js